export const uspsConfig = Object.freeze([
  { transKey: 'instant_delivery', color: 'link', type: 'check' },
  { transKey: 'certified_reseler', color: 'link', type: 'check' },
  { transKey: 'secure_payment', color: 'link', type: 'check' },
])
